// Titres courts des sous-themes (generes une fois via LLM, statiques).
export const SUBTOPICS = {
  "basic": {
    "B-001-001": "Pouvoirs et responsabilités réglementaires",
    "B-001-002": "Informations sur le certificat et adresse",
    "B-001-003": "Infractions et émissions interdites",
    "B-001-004": "Conditions pour obtenir un certificat",
    "B-001-005": "Privilèges des titulaires de certificat",
    "B-001-006": "Utilisation et limitations des stations",
    "B-001-007": "Règles d'émission et contenu interdit",
    "B-001-008": "Emplacement et types de stations",
    "B-001-009": "Responsabilités des opérateurs",
    "B-001-010": "Interférences et hiérarchie des services",
    "B-001-011": "Communications en situations d'urgence",
    "B-001-012": "Éthique et rémunération radioamateur",
    "B-001-013": "Identification des stations canadiennes",
    "B-001-014": "Utilisation tierce et communications internationales",
    "B-001-015": "Privilèges et compétences radioamateur",
    "B-001-016": "Largeur de bande autorisée",
    "B-001-017": "Puissance d'émission et limites",
    "B-001-018": "Retransmission et signaux automatiques",
    "B-001-019": "Surveillance contre la surmodulation",
    "B-001-020": "Messages internationaux et régulations",
    "B-001-021": "Régions et Règles IUT",
    "B-001-022": "Examens et Frais Radioamateurs",
    "B-001-023": "Règles Installation Antennes",
    "B-001-024": "Sécurité Rayonnements RF",
    "B-001-025": "Critères Brouillage Émissions",
    "B-002-001": "Utilisation et Coordination Répéteurs",
    "B-002-002": "Identification Phonie Alpha",
    "B-002-003": "Appels CQ et Simplex",
    "B-002-004": "Pratiques d’Émission Optimale",
    "B-002-005": "CQ en Code Morse",
    "B-002-006": "Rapport de signal RST",
    "B-002-007": "Codes Q essentiels",
    "B-002-008": "Signaux de détresse",
    "B-002-009": "Cartes QSL et orientation",
    "B-003-001": "Filtres passe-bas HF",
    "B-003-002": "Transmission FM micro",
    "B-003-003": "Récepteur FM composants",
    "B-003-004": "Émetteur CW structure",
    "B-003-005": "Récepteur CW et BLU",
    "B-003-006": "Émetteur BLU étapes",
    "B-003-007": "Connexions radio numérique",
    "B-003-008": "Alimentation stabilisée interne",
    "B-003-009": "Antennes Yagi éléments",
    "B-003-010": "Modes émission et sensibilité",
    "B-003-011": "Pépiement et oscillateurs",
    "B-003-012": "Réglages émission BLU",
    "B-003-013": "Excursion fréquence FM",
    "B-003-014": "Équipements émission téléphonie",
    "B-003-015": "Radiocommunications paquets AX.25",
    "B-003-016": "Sources d'énergie électrique",
    "B-003-017": "Alimentation et fonctionnement électro",
    "B-003-018": "Sécurité d’usage du matériel radio",
    "B-003-019": "Mise à la terre et protection électrique",
    "B-003-020": "Protection contre la foudre station",
    "B-003-021": "Précautions en UHF et micro-ondes",
    "B-004-001": "Amplification des signaux radio",
    "B-004-002": "Fonction et usage des diodes Zener",
    "B-004-003": "Transistors et amplification faible signal",
    "B-004-004": "Transistors à effet de champ FET",
    "B-004-005": "Triodes vs transistors en amplification",
    "B-004-006": "Lecture des résistances",
    "B-005-001": "Unités de mesure électrique",
    "B-005-002": "Matériaux conducteurs et isolants",
    "B-005-003": "Puissance électrique expliquée",
    "B-005-004": "Loi d'Ohm et calculs",
    "B-005-005": "Résistances en parallèle",
    "B-005-006": "Puissance et résistances",
    "B-005-007": "Fréquences et signaux audio",
    "B-005-008": "Décibels et puissance",
    "B-005-009": "Inductance et capacité",
    "B-005-010": "Réactance en courant alternatif",
    "B-005-011": "Transformateur et courant primaire",
    "B-005-012": "Principes de résonance électrique",
    "B-005-013": "Mesure électrique en circuit",
    "B-006-001": "Impédance et lignes de transmission",
    "B-006-002": "Types de lignes de transmission",
    "B-006-003": "Avantages des lignes coaxiales",
    "B-006-004": "Optimisation des systèmes d'antennes",
    "B-006-005": "Interprétation du ROS-mètre",
    "B-006-006": "Adaptation d'impédance antenne",
    "B-006-007": "Polarisation des ondes EM",
    "B-006-008": "Longueur antenne et fréquence",
    "B-006-009": "Antennes directionnelles beam",
    "B-006-010": "Calculs longueur antenne",
    "B-006-011": "Éléments antenne Yagi",
    "B-006-012": "Caractéristiques antennes dipôle",
    "B-006-013": "Antennes quad et delta",
    "B-007-001": "Propagation ondes VHF et ionosphère",
    "B-007-002": "Formation de l'ionosphère",
    "B-007-003": "Zones de silence et distances",
    "B-007-004": "Propagation Ondes HF Diurnes",
    "B-007-005": "Influence Taches Solaires Ionosphère",
    "B-007-006": "Fréquences Critiques et MUF",
    "B-007-007": "Propagation Troposphérique et 6 mètres",
    "B-007-008": "Propagation Inhabituelle des Signaux",
    "B-008-001": "Causes et Effets Brouillage RF",
    "B-008-002": "Réduction Brouillage Audio Domestique",
    "B-008-003": "Prévention Brouillage Clé et Spurious",
    "B-008-004": "Harmoniques et Interférences Télévision",
    "B-008-005": "Filtres HF contre Harmoniques"
  },
  "advanced": {
    "A-001-001": "Constante de temps RL et RC",
    "A-001-002": "Effet pelliculaire RF",
    "A-001-003": "Résonance RLC série",
    "A-001-004": "Résonance RLC parallèle",
    "A-001-005": "Facteur qualité Q RLC",
    "A-002-001": "Matériaux semi-conducteurs",
    "A-002-002": "Types de diodes",
    "A-002-003": "Paramètres transistor bipolaire",
    "A-002-004": "Transistors à effet de champ",
    "A-002-005": "Redresseur commandé SCR",
    "A-002-006": "Classes d'amplificateurs et signal",
    "A-002-007": "Impédances et amplificateurs FET",
    "A-002-008": "Amplificateurs opérationnels",
    "A-002-009": "Le mélangeur (principe)",
    "A-002-010": "Circuits logiques fondamentaux",
    "A-002-011": "Filtres en treillis à quartz",
    "A-002-012": "Types et caractéristiques des filtres",
    "A-003-001": "Mesures d'ondes sinusoïdales",
    "A-003-002": "Puissance en modulation BLU",
    "A-003-003": "Le dip-mètre (ondemètre)",
    "A-003-004": "Fonctionnement et précision du fréquencemètre",
    "A-003-005": "Oscilloscope et tracé Lissajous",
    "A-003-006": "Conversion d'ampèremètre et voltmètre",
    "A-004-001": "Redresseurs et tensions de sortie",
    "A-004-002": "Filtrage et régulation d'alimentation",
    "A-004-003": "Régulateurs de tension linéaires et découpage",
    "A-004-004": "Dissipation et performance des régulateurs",
    "A-005-001": "Oscillateurs et rétroaction",
    "A-005-002": "Étages amplificateurs de puissance",
    "A-005-003": "Transformateur RF et émission CW",
    "A-005-004": "Modulation et signaux BLU",
    "A-005-005": "Indice de modulation FM",
    "A-005-006": "Intermodulation et répéteurs",
    "A-005-007": "Traitement du signal BLU",
    "A-005-008": "Codes numériques et protocoles",
    "A-005-009": "Communications étalement spectre",
    "A-006-001": "Récepteurs superhétérodynes",
    "A-006-002": "Fonctionnement mélangeur RF",
    "A-006-003": "Bruit et amplification RF",
    "A-006-004": "Détection et distorsion FM",
    "A-006-005": "Sensibilité et fréquence image",
    "A-007-001": "Types de blocs d'accord d'antenne",
    "A-007-002": "Impédance des lignes quart-onde",
    "A-007-003": "Adaptateurs d'impédance antenne",
    "A-007-004": "Distribution courant en dipôle",
    "A-007-005": "Polarisation circulaire",
    "A-007-006": "Puissance et pertes antenne",
    "A-007-007": "Hauteur d'antenne et rayonnement",
    "A-007-008": "Résistance de rayonnement antenne",
    "A-007-009": "Les guides d'onde"
  }
};
